import PieChartComponent from './PieChartComponent';
import BarChartComponent from './BarChartComponent';
import LineChartComponent from './LineChartComponent';
import ButtonComponent from './ButtonComponent';
import ButtonTabularComponent from './ButtonTabularComponent';
import CardComponent from './CardComponent';
import CircularProgressbarComponent from './CircularProgressBarComponent';
import ProgressBarComponent from './ProgressBarComponent';
import StackedBarChart from './StackedBar';
import GroupedBar from './GroupedBar';

const WidgetRenderer = ({
  widget_type,
  cubeResponse,
  target,
  annotation,
  formikData,
  onClickHandler,
  showButtonPreview,
  widgetId,
  dashboardLogDetails = null,
  dashboardDetails = null,
  compareToResponse = null,
  item,
}) => {
  switch (true) {
    case widget_type == 'pie-chart':
      return (
        <PieChartComponent
          cubeResponse={cubeResponse}
          annotation={annotation?.dimensions}
          dashboardLogDetails={dashboardLogDetails}
          dashboardDetails={dashboardDetails}
        />
      );
    case widget_type == 'gauge':
      return (
        <CircularProgressbarComponent
          cubeResponse={cubeResponse}
          target={target}
          annotation={annotation?.measures}
          dashboardLogDetails={dashboardLogDetails}
          dashboardDetails={dashboardDetails}
          compareToResponse={compareToResponse}
          formikData={formikData}
        />
      );
    case widget_type == 'bar-chart':
      return (
        <BarChartComponent
          cubeResponse={cubeResponse}
          annotation={annotation?.dimensions}
          valueAnnotation={annotation?.measures}
          dashboardLogDetails={dashboardLogDetails}
          dashboardDetails={dashboardDetails}
          formikData={formikData}
        />
      );
    case widget_type == 'external-link-button' && showButtonPreview:
      return <ButtonComponent formikData={formikData} />;
    case widget_type == 'line-chart':
      return (
        <LineChartComponent
          cubeResponse={cubeResponse}
          annotation={annotation?.dimensions}
          valueAnnotation={annotation?.measures}
          dashboardLogDetails={dashboardLogDetails}
          dashboardDetails={dashboardDetails}
          formikData={formikData}
        />
      );
    case widget_type == 'tabular-report':
      return (
        <ButtonTabularComponent
          formikData={formikData}
          onClickHandler={onClickHandler}
        />
      );
    case widget_type === 'card':
      return (
        <CardComponent
          formikData={formikData}
          cubeResponse={cubeResponse}
          showButtonPreview={showButtonPreview}
          annotation={annotation?.measures}
          widgetId={widgetId}
          dashboardLogDetails={dashboardLogDetails}
          dashboardDetails={dashboardDetails}
          compareToResponse={compareToResponse}
          item={item}
        />
      );
    case widget_type === 'progress-bar':
      return (
        <ProgressBarComponent
          cubeResponse={cubeResponse}
          target={target}
          annotation={annotation?.measures}
          dashboardLogDetails={dashboardLogDetails}
          dashboardDetails={dashboardDetails}
          compareToResponse={compareToResponse}
          formikData={formikData}
          showButtonPreview={showButtonPreview}
        />
      );
    case widget_type == 'stacked-bar':
      return (
        <StackedBarChart
          cubeResponse={cubeResponse}
          target={target}
          dashboardLogDetails={dashboardLogDetails}
          dashboardDetails={dashboardDetails}
          compareToResponse={compareToResponse}
          formikData={formikData}
          showButtonPreview={showButtonPreview}
          annotation={annotation?.dimensions}
          valueAnnotation={annotation?.measures}
        />
      );
    case widget_type === 'grouped-bar':
      return (
        <GroupedBar
          cubeResponse={cubeResponse}
          target={target}
          dashboardLogDetails={dashboardLogDetails}
          dashboardDetails={dashboardDetails}
          compareToResponse={compareToResponse}
          formikData={formikData}
          showButtonPreview={showButtonPreview}
          annotation={annotation?.dimensions}
          valueAnnotation={annotation?.measures}
        />
      );

    default:
      return null;
  }
};

export default WidgetRenderer;
